<template>
  <div >
    <van-nav-bar
      title="素材搜索"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />
    <van-search v-model="value" placeholder="请输入搜索关键词"      @search="tosearch(1)"/>
    <div @scroll="pageScroll" style="overflow-y:scroll;height: 844px;">
      <van-grid :border="false" :column-num="2" >
        <van-grid-item :ref="item.image" v-for="item in sucaidata" :key="item.image"  @click="openimage(item.image)"  >
          <van-image height="150" width="150" :src="item.image" />
          <p style="font-size: 12px;">{{item.name}}</p>
        </van-grid-item>

      </van-grid>

    </div>








  </div>
</template>

<script>
  import * as Api from './api.js'
import { ImagePreview,Toast } from 'vant';

  export default {
    name: 'sucaiview',
    data () {
      return {
        value:'',
        sucaidata:[],
        pageNo:1,
        total:0,
        isnext:false,
        selitem:''




      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      this.tosearch(1)
    },
    methods:{
      tosearch(){
        this.sucaidata = []
        this.getsucaifile(1)
      },
      getsucaifile(page){
        var that =this
        this.loading = true

        let query = {
          name:this.value,
          limit:20,
          page:page

        }
        Api.getsucais(query).then(res=>{
          this.isnext = res.data.is_next
          this.total = res.data.total
          res.data.data.forEach(item=>{

            item.images.split(',').forEach(img=>{
              let info = {
                  catename:item.catename,
                  name :item.name,
                  image:img
              }

              that.sucaidata.push(info)
            })

          })

        })

      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      clickselitem(item){
        this.selitem=item
        //this.selitem = item.image
        console.log(item.image)
      },
      openimage(img){
        ImagePreview([img]);
      },
      pageScroll(e){
            // 滑动条滚动时，距离顶部距离
            var scrollTop=e.target.scrollTop
            // 可视区高度
            var windowHeight=e.target.clientHeight
            // 滑动条总高度
            var scrollHeight=e.target.scrollHeight
            // 滑动条到达底部的条件
            if(scrollTop+windowHeight==scrollHeight){
              if(this.isnext){
                this.pageNo++
                // 获取下一页数据
                this.getNext()
                console.log('获取下一页数据')
              }else{
                Toast('已经到底了')
              }
            }



      },
      getNext(){
        this.getsucaifile(this.pageNo)
      }

    }
  }

</script>

<style>
  .scroll-container {
     /* 设置一个固定高度 */
    overflow-y: auto; /* 开启垂直滚动条 */
  }
  .selectborder{
    border: 1px dashed red;
  }
</style>



// WEBPACK FOOTER //
// src/views/sucaiview/sucailist/index.vue